import type {Editor} from "slate";

import {getCoeditorVariables} from "@khan/guide-coeditor-core";
import {isKhanmigoEditing} from "@khan/guide-math-editor";

const PARENT_KHANMIGO_TOOLS_PATH = "/parent/khanmigo-tools";
const TEACHER_KHANMIGO_TOOLS_PATH = "/teacher/khanmigo-tools";
const ADMIN_KHANMIGO_TOOLS_PATH = "/districts/khanmigo-activities";

export default function shouldAutosaveCoeditor(
    threadId: string | null | undefined,
    currentPathname: string,
    editor: Editor | null,
): boolean {
    if (!threadId || !editor) {
        return false;
    }

    const {started} = getCoeditorVariables();
    if (!started) {
        return false;
    }

    if (isKhanmigoEditing(editor)) {
        return false;
    }

    if (
        !currentPathname.includes(TEACHER_KHANMIGO_TOOLS_PATH) &&
        !currentPathname.includes(PARENT_KHANMIGO_TOOLS_PATH) &&
        !currentPathname.includes(ADMIN_KHANMIGO_TOOLS_PATH)
    ) {
        return false;
    }

    return true;
}
